// File: app/src/components/ChatHeader.jsx
import React from 'react';

export default function ChatHeader() {
  return (
    <div>
      Portal of Cosmic Knowledge
    </div>
  );
}